import type { MainPageState } from "../../../hooks/useMainPageState";
import type { CopyRow } from "./copyPlan";
import { useCopyToOwnRows } from "./useCopyToOwnRows";

/** The grid's `getContextMenuItems`, wired from the page state. */
export function useCopyMenu(state: MainPageState) {
  const { workspace, selectedRows, editableProducer, canSave } = state;

  return useCopyToOwnRows({
    state: {
      // Save waits for a write in flight too. The item greys for that itself,
      // with a reason, so the page gate takes Save's verdict that aside.
      canSave: canSave || workspace.isWriting,
      planBy: workspace.tableControls.planBy,
      editableProducer,
      isWriting: workspace.isWriting,
      metaData: workspace.metaData
    },
    selectedRows: selectedRows as CopyRow[],
    queueWrite: workspace.queueWrite,
    setToastState: workspace.setToastState
  });
}
